import React, { useEffect, useState } from 'react';
import { Tab, TabBody, TabBarIcon, TabBarLabel, TabBar, TabBarItem, Toast, Popup } from 'react-weui';
import SearchInput from '@/components/SearchInput';
import Swiper from './components/Swiper';
import { history } from 'umi';
import AppLaunch from '@/components/AppLaunch';
import { updateWxShareInfo } from '@/utils/utils';

import iconDt from '@/assets/live/icon_dt.png';
import iconJf from '@/assets/live/icon_jf.png';
import iconQd from '@/assets/live/icon_qd.png';
import coverImg from '@/assets/live/cover.png';
import fireImg from '@/assets/live/fire.svg';

import iconPlay from '@/assets/live/play.png';
import iconKt from '@/assets/live/icon_kt.png';
import iconSc from '@/assets/live/icon_sc.png';
import iconSq from '@/assets/live/icon_sq.png';
import iconUser from '@/assets/live/icon_user.png';
import iconZb from '@/assets/live/icon_zb.svg';
import shopLink from '@/assets/live/shop_link.jpg';

import promoteIcon from '@/assets/live/promote_icon.png';

import { getVzanList, getChannelList, getSwiperList, createVzanPoints } from '@/services/vzan';
import { getUserInfo } from '@/services/myself';

import styles from './styles.scss';
import icon_share from '@/assets/live/icon_share.png';

const grids_data = [
  {
    icon: (<AppLaunch appPath={"pages/sign/index"}>
      <img src={iconQd}/>
    </AppLaunch> ),
    label: '签到处',
    click: () => {
      console.log('this is qd');
    }
  }, {
    icon: <img src={iconJf}/>,
    label: '积分宝',
    click: () => {
      history.push('/live/points')
    }
  }, {
    icon: (<AppLaunch appPath={"pages/answer/start/start"}>
      <img src={iconDt}/>
    </AppLaunch> ),
    label: '答题屋',
    click: () => {
      console.log('this is dt');
    }
  }
];

const renderGrid = (item) => (
  <div onClick={() => {
    if (typeof item.click === 'function') {
      item.click();
    }
  }}>
    {item.icon}
    <div className={styles.gridLabel}>{item.label}</div>
  </div>
)

const CURRENT_NAV_KEY = "current";
const OLD_NAV_KEY = "old";


const ShopLaunch = ({children}) => {
  return (
    <div style={{position: "relative"}}>
      {children}
      <wx-open-launch-weapp
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
        }}
        id={'launch-btn'}
        username={'gh_1915308a9815'}
        path={'pages/index/index'}
      >
        <script type="text/wxtag-template">
          <div style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }}/>
        </script>
      </wx-open-launch-weapp>
    </div>
  )
}

const PROMOTE_URL = "https://wx.vzan.com/plug-ins/#/recruiting/99449951";

export default () => {
  const [bannerList, setBannerList] = useState([{
    imgUrl: coverImg,
    link: '',
  }]);
  const [user, setUser] = useState({});
  const [currentNav, setCurrentNav] = useState(CURRENT_NAV_KEY);
  const [liveList, setLiveList] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [showSharePage, setShowSharePage] = useState(false);
  const [currentChannelParent, setCurrentChannelParent] = useState(null);

  const [showPopNav, setShowPopNav] = useState(false);

  useEffect(() => {

    getSwiperList().then(res => {
      if (res.code === 200 && Array.isArray(res.data) && res.data.length > 0) {
        setBannerList(res.data)
      }
    })

    refreshVzanList();

    refreshVzanChannelList();

    getUserInfo().then(res => {
      if (res && res.code === 200) {
        setUser(res.data);
      }else {
        // Toast.fail('获取失败，请重试');
      }
    });



  }, []);

  const refreshVzanList = () => {
    getVzanList().then(res => {
      if (res.code === 200) {
        setLiveList(res.data.list);
      }
    });
  }

  const refreshVzanChannelList = () => {
    getChannelList().then(res => {
      if (res.code === 200) {
        setChannelList(res.data.list);
      }
    });
  }

  const redirectToVzan = ({watchUrl}) => {
    if (watchUrl) {
      createVzanPoints('watch')
        .then(res => console.log(res))
        .finally(() => {
          window.location.href=watchUrl;
        });
    }
  }

  const handleShare = (e, item) => {
    // 禁用click事件上浮
    e.stopPropagation();
    const title = item.title;
    const desc = '';
    const link = item.watchUrl;
    const imgUrl = item.banner;

    setShowLoading(true);

    updateWxShareInfo({
      title,
      desc,
      link,
      // imgUrl: `${window.location.origin}/logo.png`,
      imgUrl,
      successConfig: () => {
        setShowLoading(false);
        setShowSharePage(true);
        createVzanPoints('share')
          .then(res => console.log(res))
          .finally(() => {
          });
      },
      successCallback: () => {
      }
    });

  }

  return (
    <div style={{height: "100vh", overflow: 'auto'}}>
      <div style={{paddingBottom: '65px'}}>
        <SearchInput placeholder={'请输入您想要查询的课程名称或内容'} disable onClick={()=> {
          history.push('/home/search');
        }}/>

        {/*<Swiper bannerList={bannerList} />*/}

        <div className={styles.liveHeaderContainer}>

          <img src={shopLink} />
          <wx-open-launch-weapp
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
            }}
            id={'launch-btn'}
            username={'gh_1915308a9815'}
            path={"pages/index/index"}
          >
            <script type="text/wxtag-template">
              <div style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }}/>
            </script>
          </wx-open-launch-weapp>
        </div>

        {/*<Grids data={grids_data} />*/}

        <div className={styles.liveGridContainer}>

          {
            grids_data.map((item, index) => (
              <div className={styles.gridItem} key={index}>
                {renderGrid(item)}
              </div>
            ))
          }

        </div>

        <div className={styles.liveGridContainer}>
          <div
            onClick={() => {
              setCurrentNav(CURRENT_NAV_KEY);
              setCurrentChannelParent(null);
            }}
            className={styles.listNav + " " + (currentNav === CURRENT_NAV_KEY ? styles.listNavActive : "")}>
            <div>本期栏目</div>
            <div></div>
          </div>
          <div
            onClick={() => {
              setCurrentNav(OLD_NAV_KEY);
              setCurrentChannelParent(null);
            }}
            className={styles.listNav + " " + (currentNav === OLD_NAV_KEY ? styles.listNavActive : "")}>
            <div>往期栏目</div>
            <div></div>
          </div>
        </div>

        <div style={{display: currentNav === OLD_NAV_KEY ? '' : 'none'}} className={styles.listContainer}>
          {
            channelList.filter(t => {
              if (currentChannelParent) {
                return currentChannelParent === t.vzanParentId;
              } else {
                return !t.vzanParentId || "0" === t.vzanParentId;
              }
            }).sort((a, b) => {
              return (b.vzanType - a.vzanType ) || (a.sort - b.sort);
            }).map((item, index) => {

              if (item.vzanType === 2) {

                return (

                  <div onClick={() => setCurrentChannelParent(item.vzanId)} className={styles.listItem} key={index}>
                    <div>
                      <img src={item.banner} />
                    </div>
                    <div>
                      <div className={styles.title}>{item.title}</div>
                      {/*<div className={styles.time}>已经更新&nbsp;{item.topicCount}&nbsp;期</div>*/}
                      <div className={styles.time}>已经更新&nbsp;{item.topicCount}&nbsp;期</div>
                    </div>
                  </div>

                )
              }

              return (
                <div onClick={() => redirectToVzan(item)} className={styles.listItem} key={index}>
                  <div>
                    <img src={item.banner} />
                  </div>
                  <div>
                    <div className={styles.title}>{item.title}</div>
                    {/*<div className={styles.time}>已经更新&nbsp;{item.topicCount}&nbsp;期</div>*/}
                    <div className={styles.time}>视频&nbsp;{item.startTime}</div>
                    <div className={styles.footer}>
                      <div className={styles.hotContainer}>
                        <img src={iconPlay} />&nbsp;重播
                      </div>
                      <div className={styles.shareContainer} onClick={(e) => handleShare(e, {
                        ...item,
                        watchUrl: `${window.location.origin}/live/detail/channel/${user.id}/${item.id}`
                      })}>
                        <div className={styles.button}>分享</div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>

        <div style={{display: currentNav === CURRENT_NAV_KEY ? '' : 'none'}} className={styles.listContainer}>
          {
            liveList.map((item, index) => (
              <div onClick={() => redirectToVzan(item)} className={styles.listItem} key={index}>
                <div>
                  <img src={item.banner} />
                </div>
                {/*  "status": "直播状态 -1：未开始 1：直播中 0：已结束 2：已暂停", */}
                <div style={{color: item.vzanStatus === -1 ? '#007AF8' : ''}} >
                  <div className={styles.title} >{item.title}</div>
                  <div className={styles.time}>视频&nbsp;{item.startTime}</div>
                  <div className={styles.footer}>
                    <div className={styles.hotContainer}>
                    {/*{*/}
                    {/*  item.vzanStatus === -1 ?*/}
                    {/*    <>*/}
                    {/*      <img src={fireImg} />&nbsp;{item.pv}&nbsp;热度*/}
                    {/*    </> : null*/}
                    {/*}*/}
                      {
                        item.vzanStatus === -1 || item.vzanStatus === 1 || item.vzanStatus === 2 ?
                          <>
                            <img src={iconPlay} />&nbsp;直播
                          </> : null
                      }
                      {
                        item.vzanStatus === 0 ?
                          <>
                            <img src={iconPlay} />&nbsp;重播
                          </> : null
                      }
                    </div>
                    <div className={styles.shareContainer} onClick={(e) => handleShare(e, {
                      ...item,
                      watchUrl: `${window.location.origin}/live/detail/topic/${user.id}/${item.id}`
                    })}>
                      <div className={styles.button}>分享</div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>

      <div>
        <TabBar>
          <TabBarItem
            onClick={() => history.push('/nav/home')}
            icon={<img src={iconKt}/>}
            label="课堂"
          />
          <TabBarItem
            onClick={() => window.open('https://www.weizan.cn/f/s-1128230')}
            icon={<img src={iconSq}/>}
            label="社群"
          />
          <TabBarItem
            onClick={() => { }}
            icon={<img src={iconZb}/>}
            label="直播"
          />

          <TabBarItem
            // onClick={e=>this.setState({tab:1})}
          >
            <ShopLaunch name={"gh_1915308a9815"} appPath={"pages/index/index"}>
            <TabBarIcon><img src={iconSc}/></TabBarIcon>
            <TabBarLabel>商城</TabBarLabel>
            </ShopLaunch>
          </TabBarItem>


          {/*<TabBarItem*/}
          {/*  // style={{backgroundColor: "#787878"}}*/}
          {/*  // onClick={() => window.open('http://mall.jd.com/index-764783.html ')}*/}
          {/*  icon={*/}

          {/*      <img src={iconSc}/>*/}

          {/*  }*/}
          {/*  label="商城"*/}
          {/*/>*/}

          <TabBarItem
            onClick={() => window.open('https://wx.vzan.com/live/mine-99449951')}
            icon={<img src={iconUser}/>}
            label="个人"
          />

        </TabBar>
      </div>

      <button
        onClick={() => window.open(PROMOTE_URL)}
        className={styles.promoteContainer}>
        <img src={promoteIcon} />
      </button>

      <Toast icon="loading" show={showLoading}>加载中...</Toast>

      <Popup show={showSharePage} style={{'opacity': '0.9'}} onRequestClose={() => setShowSharePage(false)}>
        <div className={styles.popupContainer} onClick={() => setShowSharePage(false)}>
          <img src={icon_share} />

          {/*<div className={styles.title}>点击这里分享给其他用户。</div>*/}

        </div>
      </Popup>

      <Popup show={showPopNav} style={{'opacity': '0.9'}} onRequestClose={() => setShowPopNav(false)}>
        这里是弹出导航
      </Popup>

    </div>
  )
}
